var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHero1 = function SvgHero1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hero_1_svg__hero",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 550 993",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient",
    cx: 52.8559,
    cy: 675.8407,
    r: 467.5276,
    gradientTransform: "translate(10.4853 28.5109) scale(0.9679 0.9657)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1653,
    stopColor: "#58b8c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3705,
    stopColor: "#5fa8bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#6b8fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8362,
    stopColor: "#7c6ca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a509b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-2",
    cx: 311.6303,
    cy: 710.8626,
    r: 159.4441,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-3",
    cx: 346.6374,
    cy: 761.9505,
    r: 141.3233,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-4",
    cx: 262.5312,
    cy: 716.0338,
    r: 135.8014,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-5",
    cx: 176.2747,
    cy: 705.5997,
    r: 150.0409,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-6",
    cx: 263.8242,
    cy: 716.0604,
    r: 110.8524,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-7",
    cx: 232.1758,
    cy: 741.6429,
    r: 95.8963,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-8",
    cx: 153.9066,
    cy: 841.4069,
    r: 190.8256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3adbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#a3aac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#a3a2cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#a294e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#a280fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-9",
    cx: 252.6097,
    cy: 1035.9182,
    r: 223.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#5d47c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#6653c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#7668cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8b84da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9794e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-10",
    cx: 292.0649,
    cy: 665.2882,
    r: 192.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f85aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2373,
    stopColor: "#8085ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#8284ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    stopColor: "#8682cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    stopColor: "#8b7feb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c7ff0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-11",
    cx: 423.63,
    cy: 938.8594,
    r: 353.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b53c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2463,
    stopColor: "#7d57c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#8363cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    stopColor: "#8e78d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#9c94e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-12",
    cx: 445.0738,
    cy: 899.1384,
    r: 172.5504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#6f4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#7659c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#836ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#958adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-13",
    cx: -16.8687,
    cy: 793.4871,
    r: 261.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72b6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8eaac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-14",
    cx: 352.2484,
    cy: 938.9176,
    r: 180.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#7b81d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#858dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#95a1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b0c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-15",
    cx: 354.6064,
    cy: 991.1476,
    r: 111.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#5e4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#6859c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#7a6ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#938adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-16",
    cx: 34.277,
    cy: 705.8903,
    r: 376.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1897,
    stopColor: "#57b9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#5dadbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    stopColor: "#6798b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7701,
    stopColor: "#757cac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9636,
    stopColor: "#86589e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a509b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_1_svg__linear-gradient",
    x1: 171.1728,
    y1: 307.1782,
    x2: 454.4886,
    y2: 568.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33dc8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53bcc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7026,
    stopColor: "#67aed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#809be5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-17",
    cx: 296.8335,
    cy: 529.3289,
    r: 257.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-18",
    cx: 224.3334,
    cy: 385.2977,
    r: 255.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-19",
    cx: 263.3642,
    cy: -33.0583,
    r: 230.4185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#99f76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-20",
    cx: 345.4066,
    cy: 6.0824,
    r: 83.0279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#6af66f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe988"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-21",
    cx: 105.6158,
    cy: 17.775,
    r: 296.3492,
    xlinkHref: "#hero_1_svg__radial-gradient-19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-22",
    cx: 462.5495,
    cy: 248.456,
    r: 201.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6662,
    stopColor: "#3dd9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-23",
    cx: 214.1126,
    cy: 525.4066,
    r: 217.1362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-24",
    cx: 254.2035,
    cy: 548.5021,
    r: 230.9947,
    xlinkHref: "#hero_1_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-25",
    cx: 25.189,
    cy: 268.0303,
    r: 265.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#a0f576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-26",
    cx: 0.9391,
    cy: 140.8946,
    r: 304.2782,
    xlinkHref: "#hero_1_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-27",
    cx: 313.6699,
    cy: 362.4559,
    r: 141.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b56c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-28",
    cx: 426.022,
    cy: 270.3462,
    r: 197.7039,
    xlinkHref: "#hero_1_svg__radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-29",
    cx: 63.2571,
    cy: 682.0559,
    r: 272.5343,
    xlinkHref: "#hero_1_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-30",
    cx: 36.5099,
    cy: 567.5495,
    r: 199.4696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe47d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc2bf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-31",
    cx: 378.6374,
    cy: 159.5769,
    r: 94.6049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bdaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad8a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-32",
    cx: 518.4062,
    cy: 309.3346,
    r: 261.2796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-33",
    cx: 371.9625,
    cy: 362.0482,
    r: 171.8521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#4ec2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#53b6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#5aa1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6485f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-34",
    cx: 383.5153,
    cy: 756.2858,
    r: 489.5842,
    gradientTransform: "matrix(0.3629, -0.9318, 0.5417, 0.211, -165.323, 954.1041)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2705,
    stopColor: "#4fc2bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    stopColor: "#57b6c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    stopColor: "#63a2cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d90d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-35",
    cx: 397.2336,
    cy: 455.1076,
    r: 268.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#51c3c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    stopColor: "#5db8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#72a7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8718,
    stopColor: "#8e90ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-36",
    cx: 416.399,
    cy: 392.5495,
    r: 162.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3da6c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    stopColor: "#6ac0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83cfa3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-37",
    cx: 453.8262,
    cy: 575.2978,
    r: 293.9045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#24bea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7629,
    stopColor: "#65ce99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ed493"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-38",
    cx: 491.2022,
    cy: 293.0107,
    r: 147.9075,
    gradientTransform: "translate(0.4565 -0.4253) rotate(0.0305)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#42c0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8041,
    stopColor: "#83cb9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccf99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-39",
    cx: 455.2031,
    cy: 415.7366,
    r: 249.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#60c5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8334,
    stopColor: "#a2e0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbeb99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-40",
    cx: 234.078,
    cy: 172.0016,
    r: 173.2893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4002,
    stopColor: "#45cbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    stopColor: "#86e0b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fe8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-41",
    cx: 41.1882,
    cy: 661.7907,
    r: 247.6438,
    xlinkHref: "#hero_1_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-42",
    cx: 355.4011,
    cy: 889.767,
    r: 195.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b78d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#6e7cd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#7688d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#859ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8da8c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-43",
    cx: 527.9294,
    cy: 803.0336,
    r: 198.4273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7149c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    stopColor: "#724dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#7659cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#7c6ed7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#858ae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#91aefd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92b2ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-44",
    cx: 401.2038,
    cy: 640.254,
    r: 176.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6e473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fbfc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-45",
    cx: 339.3634,
    cy: 583.6914,
    r: 45.5138,
    xlinkHref: "#hero_1_svg__radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-46",
    cx: 235.6572,
    cy: 533.6938,
    r: 286.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76eaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7388ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-47",
    cx: 219.2581,
    cy: 589.5922,
    r: 184.2543,
    xlinkHref: "#hero_1_svg__radial-gradient-46"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-48",
    cx: 266.5856,
    cy: 653.8335,
    r: 199.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#4fc3c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#53bbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#5baee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#669cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#669bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-49",
    cx: 59.9862,
    cy: 617.4264,
    r: 317.9666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dafd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51aed2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dadd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72aace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8ea5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-50",
    cx: 316.6319,
    cy: 603.9451,
    r: 269.6183,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-51",
    cx: 218.5352,
    cy: 563.784,
    r: 199.0771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78c6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#77c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#74b6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#6fa1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6885f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-52",
    cx: 132.095,
    cy: 656.7777,
    r: 85.8599,
    xlinkHref: "#hero_1_svg__radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-53",
    cx: 129.0434,
    cy: 430.2192,
    r: 345.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96e46f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#6fbbd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-54",
    cx: 76.3956,
    cy: 606.6099,
    r: 177.4849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96e46f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fbbd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-55",
    cx: 46.3628,
    cy: 442.4149,
    r: 177.5713,
    xlinkHref: "#hero_1_svg__radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-56",
    cx: 240.5881,
    cy: 581.2124,
    r: 102.8368,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-57",
    cx: 432.0769,
    cy: 461.0275,
    r: 250.3397,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-58",
    cx: 328,
    cy: 499.6596,
    r: 262.9409,
    xlinkHref: "#hero_1_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_1_svg__linear-gradient-2",
    x1: 49.5428,
    y1: 578.65,
    x2: 171.9601,
    y2: 789.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67c6a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cc2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8067,
    stopColor: "#7cacc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95a1cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-59",
    cx: 22.6957,
    cy: 541.7582,
    r: 154.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0289,
    stopColor: "#00aca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#2ad19f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-60",
    cx: -18.4581,
    cy: 613.7195,
    r: 265.4047,
    xlinkHref: "#hero_1_svg__radial-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-61",
    cx: 73.5434,
    cy: 885.6154,
    r: 120.1059,
    xlinkHref: "#hero_1_svg__radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-62",
    cx: 77.4787,
    cy: 817.7649,
    r: 148.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2762,
    stopColor: "#27bcbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    stopColor: "#68c7c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81cbc5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-63",
    cx: 9.4892,
    cy: 662.7825,
    r: 98.6866,
    xlinkHref: "#hero_1_svg__radial-gradient-44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-64",
    cx: 80.1699,
    cy: 769.922,
    r: 200.385,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-65",
    cx: 186.1505,
    cy: 743.7802,
    r: 139.6287,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-66",
    cx: 241.6327,
    cy: 741.3113,
    r: 104.9169,
    xlinkHref: "#hero_1_svg__radial-gradient-14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-67",
    cx: 171.8407,
    cy: 725.6064,
    r: 214.7103,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-68",
    cx: 101.7143,
    cy: 742.1487,
    r: 71.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2762,
    stopColor: "#27b1b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    stopColor: "#68aac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81a7c5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-69",
    cx: 167.7446,
    cy: 587.7889,
    r: 160.5164,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-70",
    cx: 39.6484,
    cy: 373.467,
    r: 225.15,
    gradientTransform: "translate(4.3729 14.4091) scale(0.9492 0.9697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e69a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4491,
    stopColor: "#28d4a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fc1b6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-71",
    cx: 169.467,
    cy: 580.3597,
    r: 193.2267,
    xlinkHref: "#hero_1_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-72",
    cx: -18.8354,
    cy: 368.4477,
    r: 240.8936,
    xlinkHref: "#hero_1_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-73",
    cx: 125.4505,
    cy: 598.2547,
    r: 189.5396,
    xlinkHref: "#hero_1_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-74",
    cx: 196.6798,
    cy: 499.853,
    r: 134.4332,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_1_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-75",
    cx: 112.3232,
    cy: 569.3845,
    r: 146.7358,
    xlinkHref: "#hero_1_svg__radial-gradient-59"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-76",
    cx: 71.1484,
    cy: 532.7363,
    r: 55.8405,
    xlinkHref: "#hero_1_svg__radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-77",
    cx: 19.8681,
    cy: 452.9835,
    r: 70.2318,
    gradientTransform: "translate(2.5 22.5692) scale(0.9359 0.9538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32db9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13c4b4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-78",
    cx: -17.3658,
    cy: 528.9954,
    r: 247.6768,
    xlinkHref: "#hero_1_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-79",
    cx: 106.2426,
    cy: 572.2302,
    r: 164.0688,
    xlinkHref: "#hero_1_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-80",
    cx: 46.9319,
    cy: 525.2543,
    r: 97.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00abbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_1_svg__radial-gradient-81",
    cx: 52.8918,
    cy: 530.456,
    r: 86.4765,
    xlinkHref: "#hero_1_svg__radial-gradient-18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__lower"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.5631,705.972,182,756.19l27.1022,109.1278q28.5369,34.5978,58.0761,69.5327,22.306,26.3741,44.525,52.1495,39.6853-43.458,79.3706-86.9159,15.0032-34.2836,30.006-68.567L472,685.8145,367.8435,677Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__shapes_shard_01"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370,671.5q.5,10,1,20,7,35.5,14,71l6,17,78-87,8-12Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,700.5l5,8,52,53,57-83,3-7Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,671.5l-60,88,81,20Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,700.5l-76,54,97,61q-.5-11-1-22l-18-88Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,759.5l81,20-117,36,3-8,24-39Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,700.5l57,59-36,56-14-42Q256.5,737,253,700.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,866.5h-2L310.5,993l.5-9.5-9-81Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,814l-.5,4.5,22,82,4,5,88-2,4-1q1-3.5,2-7,5-28,10-56l-122-25Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,777.5l2,4q5.5,29,11,58l-.5,2.5L275.5146,814.0807Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,831.5h-1l-18,8-2.5,2.5q-4.75,30.25-9.5,60.5Q408.5,867,424,831.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,777.5q6.25,32.25,12.5,64.5L424,831.5q26.5-75.5,53-151Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,754.5,275.5,814l-7.5,8.5-58,42-5,2Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5,904,205,866.5,275.5,814Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5,904q5.5,44.5,11,89L393,902.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,754.5,275.5,814,390,777.5l87-97-107-9-117,29Z",
    style: {
      opacity: 0.88,
      fill: "url(#hero_1_svg__radial-gradient-16)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401,840.5q-4-23-8-46l10,46,17-7-17,9-6,37q2-18.5,4-37l-44-10Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,823.5l12,41,45-32-43,34,47,20-47-18q29.313,35.7359,29,36-.3232.27-32-37Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__bg-2",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.5,551.3479q-28.8227-74.3736-57.6451-148.7473-12.7015-50.8872-25.4029-101.7744Q423.8361,186.8193,386.22,72.8123l-44.9437-29.358q-15.144-17.1255-30.2881-34.251l-42.9895,42.08L181.0428,208.8378q-8.7933,25.4436-17.5866,50.8872L76.5,389.8788q10.7474,61.1627,21.4948,122.3251l-8.7933,18.5934q8.3047,33.7617,16.61,67.5234,18.5637,37.1868,37.1273,74.3737l37.1274,75.3522,95.481,57.1567L387.8952,769.07l84.8972-94.2942.384-1.1032Q508.8382,612.51,544.5,551.3479Z",
    style: {
      fill: "url(#hero_1_svg__linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__shapes_color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5,390l4.5,3.5,72,97-9,93-44-66-1-3Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,232.5l-52,85-2,2q5.5-43.5,11-87Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,35l.5,1.5s-10.2095,48.2632-11,52l-37,45-3-2q-12.5-43-25-86l.5-2.5,44-43Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,65,382,69.5l-41,16L331.5,88q5.5-26.5,11-53Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,132l1.5,3.5,9,49-1,47-9,6-70,21-46-50-1.5-3.5,90-162Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,185.5l58,22q-2.5-35.5-5-71l-22-46L331.5,88l-37,44Q298.75,158.75,303,185.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,390l4.5-1.5,61-14,4.5.5,3.5,6.5,3,104-2,6Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,375l1.5-3.5,60-67,36,89q.5,5,1,10l-2,3-90,84-2,1Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,255.5l3,1,35,47,3,6L140.5,375l-70,15Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,205,226,256.5l1,4-23,47-3,2-41-54Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,256.5l2,5,56,54,5,2q5.75-41.75,11.5-83.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,184.5l56,18-1,4-14,23-4,4-39.5.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,533l6.5,3.5,42,38,3,3,11,14,4,7-4,2-38,2-7.5-.5Q93,567.5,84.5,533Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,514.5l43,63L84.5,533Q88.75,523.75,93,514.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,65,387,70.5l-27,58-5.5,9.5-23-50Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,65l-34,73,4.5,64.5,6,9,100,86Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,275.5q.5,4,1,8l39,101,7.5,17.5Q477.25,349.75,465,297.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,275.5,549.5,554l-6.5,5.5-117,51-37-60-7-16-1.5-7.5q-1.25-67.75-2.5-135.5l59-109Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,607.5l-2,2q-5.5,21-11,42l58,29h5L549.5,554Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,391.5l-6,8-27,82,35,52,1,1Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,316.5l-49,87q31,63.5,62,127l47-48,31-91-.2528-2.1082L291,318.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,202.5l2,10,30,95,3,6h1l44-35,3-3Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,313.5l-1,1q-6.5,33-13,66-.5,5.5-1,11l63-116Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,202.5q17.5,55.5,35,111l-7,3-91,2-7-1Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5,598l2.5,1.5,24,90q1,30,2,60l-1,5Q139.25,678.25,101.5,602Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,704.5q.5,35,1,70l-1,4-114,36v-8q8.5-59.5,17-119Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.5,650,477,680.5l-87,98L388.5,706l-.5-4.5,22-46Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.5,480,302,528.5l-1,3,1,11h1l77-7,2-1Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,544.5l21-3-1-13-4,2-11,9Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,534.5l-79,7-1,3q-6.5,41-13,82,1,29,2,58l2.5,5.5,95,16,27-56q-1.25-9.25-2.5-18.5l-24-81Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,541.5l-18,1-1,2q2.5,39,5,78l1,9Q296.5,586.5,303,541.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,534.5q16.75,57.75,33.5,115.5,5.75-21.25,11.5-42.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,748.5q-.5,3-1,6l99,60q8.9167-62.0932,17.8334-124.1864L287,689.5l-92,9Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,403.5l3,12q20.5,62,41,124l2,3,17-14Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,626.5l3,64L197.5,700l-.5-2.5,22-58,67-16Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,643.5l-4,3-36,37-4.5,6.5q1.25,32.25,2.5,64.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-52)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,403.5l-2,3-44,158,21,72,4.5,7.5L291,626.5l-6-84Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5,561l-6.5.5-37,31-2.5,5.5q12.5,46,25,92l44-46Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,491.5l1,4,47,64,2.5,1.5L239,403.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,491.5,195.5,561l-46,37L136,577.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,317.5l105-4-15,78Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,256.5l63,61-50,86q-19-47-38-94Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-58)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__highlights-2",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243,251.5q-.2143-.6858,56-19,2-21,4-42-.5,21-1,42l27,1-28,2q-11.5083,79.0634-12,79-.49-.0683,10-79Q243.2164,252.18,243,251.5Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,316.5l72.3022-4.0118Q381.651,276.4942,371,240.5q12.1511,35.9941,24.3022,71.9882L421,292.5l-26.6978,22.9882Q385.4886,369.5782,385,369.5q-.4878-.075,7.3022-54.0118Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,560.5l29,45,42-16-41,18-12,40,9-40Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,45.5l30,19,16,45-17-42-25,54,24-55-41,15,41-17Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,485.5l24,68-39,19,38-16q-27.5313,49.6952-27,50,.55.3125,31-52Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,423.5l-20,56-28,30,28-28q13.7111,20.1891,14,20,.29-.1911-13-21Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,347.5l-31,56,14,32-17-33Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,657.5q1,15.5,2,31l56,11-58-9Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,559.5l9-29q-4,15.5-8,31,5.5,20,11,40l-12-39-25,19,24-20-22-33Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__lower-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__bg-3",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.1148,600.0074,174.23,687.3368l.9672,65.9822q2.9016,12.6143,5.8033,25.2285L118.1311,845.5q-7.7376-30.08-15.4754-60.16L77.5082,709.6543c-3.8172-30.989-7.1034-63.36-9.6721-97.0326Q64.3935,567.4937,63,525.2923L75.5738,518.5l59.9672,63.0712Z",
    style: {
      fill: "url(#hero_1_svg__linear-gradient-2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__shapes_shard_03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74,513.5l-14,8,6,88,21-76Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,577.5l14,20-3,9q-23.5,48.5-47,97,15.5-58.5,31-117Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,798.5l-3,5-15,43-1,5,67-70Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,720.5q8,34.5,16,69,.5,4.5,1,9-9.5,26.5-19,53l-15-61q1-6,2-12Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,609.5l2,1,34,88q.5,4.5,1,9v76q-.5,3.5-1,7L76.5,710Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,699l4.5,3.5,13,19v2q-8.5,33.5-17,67Q101.75,744.75,101.5,699Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,723.5,101.5,699q24.25-50.75,48.5-101.5,13,45.5,26,91l-4,4-48,29Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,688.5l-9,17-28,81-2.9454,12.3272L184,781.5q-3.2857-13.6647-6.5716-27.3293Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,533.5l-18,76L101.5,699,136,577.5c-4.343-4.6109-9.0036-9.2941-14-14a331.6543,331.6543,0,0,0-34-28Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,723.5q8.5,38,17,76l40-111Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,513.5l62,64-52-44Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__highlights-3",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78,709.5l12,46-15-44q-2.5-30.5-5-61Q74,680,78,709.5Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,737.5q6.5,31,13,62l-8,24,10-24,27-11-26,9,30-89-32,89Q129,767.5,122,737.5Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,698.5l-8-20,8,21q.5,12,1,24v-23l7,9-7-10,6-23Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__middle-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__bg-4",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.2542,379.5,70.8136,394.0455Q50.4067,425.0757,30,456.1061l12.339,45.5757,18.983,18.4243,19.9322,8.7272L132.5085,571.5q4.7457-39.7575,9.4915-79.5152Q139.6272,435.7425,137.2542,379.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-70)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__shapes_shard_02_color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,456.5l2-1,31,1,20,31L74.5,515,64,520.5l-4,1L40.5,503Q33.25,479.75,26,456.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,373.5l-3,5-78,77L58.5,457,26,456.5l45-67Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,492l-1.5.5-64-4-2-1L58.5,457,142,373.5Q143.75,432.75,145.5,492Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,490l-2.5,1.5-30,38-1,4,52,44q4.75-42.75,9.5-85.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,533.5l-2-3-8-14v-2q2-13.5,4-27l39.5,2.5Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,521.5l14-7,10,19Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-76)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__middle-tiny"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__bg-5",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,487.5692q-1.8718,12.8769-3.7436,25.7539L58.6538,520,2.5,501.8769,26.8333,458H57.7179Q66.609,472.7846,75.5,487.5692Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-77)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__shapes-shard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59,456.5H26l-26,46,6-3,52-41Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,456.5,78.5,487,76,488.5l-69,14H0Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,521.5l14.2327-6.3854L71,513.5l-61-10-10-1Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,487,0,502.5l74.2327,12.6146L74.5,515Q76.5,501,78.5,487Z",
    style: {
      fill: "url(#hero_1_svg__radial-gradient-81)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_1_svg__highlights-4",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,499.5l24-18-23,19,46-8-50,10,20-35Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHero1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero_1.23c3f843688066f040a5a1a82dcd17f3.svg";